import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-horizontal-steps',
	templateUrl: './horizontal-steps.component.html',
	styleUrls: ['./horizontal-steps.component.scss'],
})
export class HorizontalStepsComponent implements OnInit {

  @Input() states: horizontalSteps[];
  @Input() NoNames: boolean = false;

	constructor() {}

	ngOnInit(): void {}
}

export interface horizontalSteps {
	state: 'active' | null;
	status: 'passed' | 'failed' | 'empty';
	title: string;
}
